// extracted by mini-css-extract-plugin
export default {"btnOrange":"Auth_btnOrange__LXIXS","textOrange":"Auth_textOrange__uB0Gr","eyePostion":"Auth_eyePostion__QgrCy","goBackButton":"Auth_goBackButton__LGWCK"};